// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import '@tylertech/forge/dist/typography/forge-typography.css'; */

.card-forge-divider {
    margin-top: 20px;
    margin-bottom: 20px;
}

.forge-card-header {
    font-weight: bold;
}

.questionnaire-question-container {
    margin-top: 10px;
}

.questionnaire-answer-text-field {
    width: fit-content;
    margin-top: 10px;
    margin-bottom: 10px;
}

.nested-question {
    margin-left: 25px;
}
`, "",{"version":3,"sources":["webpack://./src/domain/segment/questionnaire/questionnaire.styles.css"],"names":[],"mappings":"AAAA,qEAAqE;;AAErE;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":["/* @import '@tylertech/forge/dist/typography/forge-typography.css'; */\n\n.card-forge-divider {\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n\n.forge-card-header {\n    font-weight: bold;\n}\n\n.questionnaire-question-container {\n    margin-top: 10px;\n}\n\n.questionnaire-answer-text-field {\n    width: fit-content;\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n\n.nested-question {\n    margin-left: 25px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
